import { render, staticRenderFns } from "./StoryCampaignGroupsTemplate.vue?vue&type=template&id=4ea0dc7a&scoped=true&"
import script from "./StoryCampaignGroupsTemplate.vue?vue&type=script&lang=js&"
export * from "./StoryCampaignGroupsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./StoryCampaignGroupsTemplate.vue?vue&type=style&index=0&id=4ea0dc7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea0dc7a",
  null
  
)

export default component.exports